<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height overflow-y-hidden">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col class="pb-1">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"                      
                      :class="[setBtnColor]"
                      @btnSave="btnSave()" @btnPrint="btnPrint()" @btnDelete="btnDelete()"                     
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Request No :'" />
                          <v-col cols="2">
                            <v-autocomplete
                              v-model="reqNo"
                              :items="reqNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>                         
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="top">
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-2 pb-2"><span class="pa-2 search">Carry Out Date: </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <DxDateBox
                          :value="plnCarryOutDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"                         
                          @value-changed="e => {plnCarryOutDte = e.value}"
                        />                        
                      </v-col>
                    </v-row>
                  </v-col>                 
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <!-- class="doubleListBox01" -->
                    <DxDataGrid
                      height="250"
                      id="gridMain"
                      :ref="gridMainRef"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />

                      <DxColumn data-field="useShipNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="Issue" />
                      <template #Issue>
                        <div>Use<br>Ship</div>
                      </template>
                      <DxColumn data-field="useLotNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="issLot" />
                      <template #issLot>
                        <div>Use<br>Lot No</div>
                      </template>
                      <DxColumn data-field="markNo" caption="Mark No" width="10%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="markSeq" caption="Mark Seq" width="3%" alignment="center" :allow-editing="false" header-cell-template="makrSeq"/>
                      <template #makrSeq>
                        <div>Mark<br>Seq</div>
                      </template>                     
                      <DxColumn data-field="maginotDte" width="5%" alignment="center" :allow-editing="false" dataType="date" format = "yyyy-MM-dd"  header-cell-template="plnDte" />
                      <template #plnDte>
                        <div>Issue<br>Plan Date</div>
                      </template>
                      <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="porNo" caption="POR No" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="porSeq" caption="POR Seq" width="3%" alignment="center" :allow-editing="false" header-cell-template="porSeq"/>
                      <template #porSeq>
                        <div>POR<br>Seq</div>
                      </template>
                      <DxColumn data-field="reqQty" caption="Qty" width="4%" alignment="center" :allow-editing="false" />
                     <DxColumn data-field="steelKind" width="4%" alignment="center" :allow-editing="false" header-cell-template="steelKind" />
                      <template #steelKind>
                        <div>Steel<br>Kind</div>
                      </template>
                     <DxColumn data-field="matlCd" caption="Material Code" width="8%" alignment="center" :allow-editing="false" />                     
                     <DxColumn data-field="shape" caption="Shape" width="4%" alignment="center" :allow-editing="false" /> 
                     <DxColumn data-field="sizes" caption="Size" width="20%" alignment="center" :allow-editing="false" />     
                      <DxColumn data-field="length" caption="Length" width="4%" alignment="center" :allow-editing="false" />              
                     <DxColumn data-field="qualityMatl" caption="Quality" width="4%" alignment="center" :allow-editing="false" />                      
                     <DxColumn data-field="unitWgt"  caption="Weight" width="5%" alignment="center" :allow-editing="false" />                     
                      <template #deliDiv>
                        <div>Delivery<br>Div</div>
                      </template>
                     
                      <DxSummary>
                        <DxTotalItem column="useShipNo" summary-type="count" display-format="TOTAL" />
                        <DxTotalItem column="reqQty" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="unitWgt" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-row no-gutters>
                  <v-col class="">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="[ 'btnAdd',
                    'btnRetrieve' //Retrieve                 
                ]"  @btnAdd="btnAdd()"
                    @btnRetrieve="btnRetrieve02()" 
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2">
                          <i-label :label="' Ship No :'" />
                          <v-col cols="1">
                            <v-select
                              v-model=" shipNo"
                              :items="shipNoList"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getLotNo()"
                            />
                          </v-col>
                          <i-label :label="' Block :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="lotNo"
                              :items="lotNoList"
                              outlined
                              dense
                              height="32"
                              @change="getCutGrp()"
                              />
                          </v-col>
                          <i-label :label="' Cut Group :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="cutGrp"
                              :items="cutGrpList"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()" 
                              />
                          </v-col>

                          <i-label :label="' Steel Kind :'" class="pl-2"/>
                          <v-col cols="1">
                            <v-select
                              v-model="steelKind"
                              :items="steelKindList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                              />
                          </v-col>
                        
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <DxDataGrid      
                      class="doubleListBox07"       
                      id="gridMain2"
                      :ref="gridMain2Ref"
                      :data-source="gridMainList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"                     
                      @cellPrepared="cellPrepared"
                      >
                      <DxPaging :enabled="false"/>
                      <DxPager :visible="false" />

                      <!-- <DxColumn data-field="chk" data-type="boolean" width="2%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
                      <template #selHeader = "{ data: cellInfo }" >
                        <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  
                          />
                      </template>
                      <template #selChkRow = "{ data: cellInfo }">
                        <DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
                          :onValueChanged="value => onValueChanged2(value, cellInfo)"                         
                        />
                      </template>  -->
                     
                      <DxColumn caption="USE" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="useShipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="useLotNo" caption="Lot No" width="4%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="useCutGrp" caption="Cut" width="3%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="useDwgPage" caption="DP" width="3%" alignment="center" :allow-editing="false" />                        
                      </DxColumn>

                      <DxColumn caption="POR" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="shipNo" caption="Ship no" width="5%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="porNo" caption="Por no" width="6%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="porSeq" caption="Por no" width="3%" alignment="center" :allow-editing="false" />
                      </DxColumn>                      
                      
                      <DxColumn data-field="markNo" caption="Mark No" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="markSeq" caption="Mark No" width="3%" alignment="center" :allow-editing="false" />                      
                                                             
                       <DxColumn data-field="useQty" width="5%" alignment="center" :allow-editing="false" header-cell-template="reserQty" />
                      <template #reserQty>
                        <div>Use<br>Qty</div>
                      </template>
                      <DxColumn data-field="useWgt" width="7%" alignment="center" :allow-editing="false" header-cell-template="StockWgt" />
                      <template #StockWgt>
                        <div>Use<br>Weight</div>
                      </template>
                      <DxColumn data-field="steelKind" width="4%" alignment="center" :allow-editing="false"  header-cell-template="steelKind" />
                      <template #steelKind>
                        <div>Steel<br>Kind</div>
                      </template>
                      <DxColumn data-field="matlCd" width="7%" alignment="center" :allow-editing="false"  header-cell-template="matlCd" />
                      <template #matlCd>
                        <div>Material<br>Code</div>
                      </template>
                      <DxColumn data-field="shape"  caption="Shape"  width="4%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="sizes" caption="Size" width="20%" alignment="center" :allow-editing="false" />     
                      <DxColumn data-field="length" caption="Length" width="4%" alignment="center" :allow-editing="false" />                                          
                       <DxColumn data-field="qualityMatl" width="5%" alignment="center" :allow-editing="false"  header-cell-template="qtyMatl" />
                      <template #qtyMatl>
                        <div>Quality<br>Material</div>
                      </template>                     
                      <DxColumn data-field="unitWgt" width="4%" alignment="center" :allow-editing="false"  header-cell-template="unitWgt" />
                      <template #unitWgt>
                        <div>Unit<br>Weight</div>
                      </template>

                      <DxSummary>
                        <DxTotalItem column="useShipNo" summary-type="count" display-format="TOTAL" />
                        <DxTotalItem column="useQty" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="useWgt" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxLookup,
    DxSelection,
    DxPager
} from 'devextreme-vue/data-grid'

import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma , getCurrentDate, toNum, getDateFormat, getDateToStringDte ,getPreDay} from '@/utils/common.js'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { epmsa220LotNo,epmsa220CutGrp,epmsa220Add,epmsa220Show, epmsa220save, epmsa220AddReq, getResNoList, epmsa220delete } from '@/api/view/hip/A/epmsa220'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import dayjs from 'dayjs';

export default {
  name: 'epmsa220',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    DxSelection,
    DxPager
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      gridMainRef: 'gridMainRef',
      gridMain2Ref: 'gridMain2Ref',

      useBtnList: ['btnSave','btnPrint','btnDelete'],
     
      setBtnColor: 'setBtnColor',

      reqNo: '',
      reqNoList: [],

      steelKind: '',
      steelKindList: [],
      cbvisible: false,   
      shipNo: '',
      shipNoList: [],
      lotNo: '',
      lotNoList: [],
      cutGrp: '',
      cutGrpList: [],

      plnCarryOutDte: '',
      remark: '',

      gridMainList: [],
      gridMainList2: [],

      editingGbn: false,
      savereqNo: ''      
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.gridMainRef)
    },
    gridInstance2() {
      return this.GetDataGrid(this.gridMain2Ref)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    totalFormat(e) {
        const result = getNumComma(Number(e.value.toFixed(2)), 2)
        return result
    },
    async init() {
      this.gridInstance.option('defaultPaging', false)
      this.gridInstance2.option('defaultPaging', false)
      this.getreqNoList()
      this.getList()
    },
    async getreqNoList(savereqNo){
       this.reqNoList = []
       let param = {
         makerCd: this.makerCd
       }
       await getResNoList(param).then(res => {
         this.reqNoList.push('New')
         res.list.forEach(e => {
           this.reqNoList.push(e.reqNo)
         });
         if(savereqNo){
           this.reqNo = savereqNo
         } else {
           this.reqNo = this.reqNoList[0]
         }
       })
    },
    async getList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.makerCd
        }

        await getCmChildCode({
          code: '',
          codegr: '',
          prtCode: 'STEEL_KIND',
          userFlag: 'Y'
        }).then(res => {
          this.steelKindList = res.list
          this.steelKind = this.steelKindList[2]
          //console.log(this.steelKindList);
                   
        })      

        await getShipNoList(param).then(res => {
          this.shipNoList.push('Select')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0]           
        })
      } finally {
        this.getLotNo()
        this.getCutGrp()
        
        this.endLoading()
      }
    },
    async getLotNo(){
      this.lotNoList = []
      let param = {        
        shipNo: this.shipNo,
        div: '220'
      }
      await epmsa220LotNo(param).then(res => {
        this.lotNoList.push('')         
        res.list.forEach(e => {
          this.lotNoList.push(e.useLotNo)
        });
       // console.log("lot no ", this.lotNoList)
        this.lotNo = this.lotNoList[0]
      })
    },
     async getCutGrp(){
      this.cutGrpList = []
      let param = {        
        shipNo: this.shipNo == 'Select' ? '' : this.shipNo,
        lotNo: this.lotNo
      }
      await epmsa220CutGrp(param).then(res => {
        this.cutGrpList.push('')
        res.list.forEach(e => {
          this.cutGrpList.push(e.useCutGrp)
        });
        this.cutGrp = this.cutGrpList[0]
      })
    },
    checkDate(e){
      if(e.value != null && e.value != ''){
          this.plnCarryOutDte = e.value
          const curDate = getPreDay(-1)         
          if(new Date(getDateFormat(this.plnCarryOutDte)) < new Date(curDate)){
            this.vToastify(this.$t("Plan date must be 1 days after current date."), 'warn')
            this.plnCarryOutDte = null
            return
          }
          //console.log(e.value)
      }      
    },
    btnRetrieve() {
      //this.getLoc()
      this.getMain()
    },
    btnRetrieve02() {      
      this.getMain2()
    },
    async getMain(savereqNo){
      try {
        let res = ''
        if(savereqNo){
          res = savereqNo
        } else {
          res = this.reqNo
        }
        this.gridMainList = []
        this.openLoading('searching')
        let param = {
          reqNo: res
        }
       
        await epmsa220Show(param).then(res => {
          let cnt = 0
          res.list.forEach(e => {
            e.id = cnt++            
            this.gridMainList.push(e)
          });
          //this.gridMainList = res.list
        })
      } finally {
        this.endLoading()
      }
    },
   
    async getMain2(){
      try {
        this.openLoading('searching')
        this.gridMainList2 = []
        let param = {

          shipNo: this.shipNo,
          cutGrp: this.cutGrp === 'All' ? '' : this.cutGrp,
          lotNo: this.lotNo === 'All' ? '' : this.lotNo,
          userId : this.makerCd,
          steelKind: this.steelKind.code
        }
        //console.log(param);
        await epmsa220Add(param).then(res => {
          let cnt = 0
          let resTotal = 0
          //if( sum( if (res_qty = 0 , 1 , 0) for all) = 0,  0 , 1 )
          if(res.list.length > 0){
             res.list.forEach(e => {
              e.id = cnt++
              // let disabled = ''         
              // if(Number(e.stockQty) > Number(e.resQty)){
              //     disabled = 'Y'
              // }else{
              //     disabled = 'N'
              // }
              e.disabled = 'N'

              if(Number(e.useQty) == 0)
                  resTotal ++;

              this.gridMainList2.push(e)
              } )                                                              
          }
           if (resTotal == 0)
              this.cbvisible = false
            else
              this.cbvisible = true
          //this.gridMainList2 = res.list        
       
        })
      } finally {     
        console.log(1)   ;
        this.endLoading()
      }
    },
    async btnAdd(){
      if(!this.reqNo || this.reqNo === 'New'){
        this.vToastify(this.$t("Please select Request No."), 'warn')
        return
      }      
      
      // const curDate = getPreDay(-1)         
      //   if(new Date(getDateFormat(this.plnCarryOutDte)) < new Date(curDate)){
      //     this.vToastify(this.$t("Plan date must be 1 days after current date."), 'warn')
      //     this.plnCarryOutDte = null
      //     return
      //   }
      
       await this.gridInstance2.saveEditData()
			 var rowSelect = await this.gridInstance2.getSelectedRowsData()			

			if (!rowSelect.length) {
				this.vToastify(this.$t('You not select data to add!!!'), 'warn')
				return
			}

      let cnt = 0
      let param = []
      console.log(rowSelect)
    
        for(var row of rowSelect){               
            row.userId  = this.userId           
            row.makerCd = this.makerCd            
            row.reqNo   = this.reqNo
           
            param.push(row)
          
        }
      
      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to add the data?'),
          'info',
            current => {
              console.log(param)
              epmsa220AddReq(param)
                .then(res => {       
                  const result = res.body.substring(0,1)           
                  if(result == 'Y'){
                    notify(this.$t('Add data is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(res.body), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.plnCarryOutDte = ''               
                  this.gridInstance2.clearSelection()
                  this.getreqNoList(this.reqNo)
                  this.getMain(this.reqNo)
                  this.getMain2()                  
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    async btnSave(){
      if(!this.plnCarryOutDte){
        this.vToastify(this.$t("Select Carry Out Date."), 'warn')
        return
      }      
      
      // const curDate = getPreDay(-1)         
      //   if(new Date(getDateFormat(this.plnCarryOutDte)) < new Date(curDate)){
      //     this.vToastify(this.$t("Plan date must be 1 days after current date."), 'warn')
      //     this.plnCarryOutDte = null
      //     return
      //   }
      
       await this.gridInstance2.saveEditData()
			 var rowSelect = await this.gridInstance2.getSelectedRowsData()			

			if (!rowSelect.length) {
				this.vToastify(this.$t('You not select data to save!!!'), 'warn')
				return
			}

      let cnt = 0
      let param = []
      console.log(rowSelect)
    
        for(var row of rowSelect){
          let maginotDte = new Date()
               
            row.userId  = this.userId           
            row.makerCd = this.makerCd            
            row.plnCarryOutDte = dayjs(this.plnCarryOutDte).format('YYYY-MM-DD')
            row.div = 'T30E_1119'

            maginotDte.setDate(maginotDte.getDate() + 1)

            if(maginotDte.getDay() === 0){
               maginotDte.setDate(maginotDte.getDate() + 1)
            }
            row.issuePndte = dayjs(maginotDte).format('YYYYMMDD')
            //row.issueShip  = row.useShipNo
            // row.issueLot   = row.useLotNo
            param.push(row)
          
        }
      
      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to save the data?'),
          'info',
            current => {
              console.log(param)
              epmsa220save(param)
                .then(res => {
                  const result = res.body.substring(0,1)
                  this.savereqNo = res.body.substring(1)
                  console.log(this.savereqNo)
                  if(result == 'Y'){
                    notify(this.$t('Saving is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(res.body), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.plnCarryOutDte = ''               
                  this.gridInstance2.clearSelection()
                  this.getreqNoList(this.savereqNo)
                  this.getMain(this.savereqNo)
                  this.getMain2()                  
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
    btnPrint(){
      if(!this.reqNo){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        fileName: 'epmsa220.jrxml',
        as_res_no: this.reqNo,
       
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(){
      await this.gridInstance.saveEditData()
      var selectedMainRows = await this.gridInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t("Data is not selected for delete."), 'warn')
        return
      }

      for(var row of selectedMainRows){
        row.div = 'T30E_1119'
        row.userId = this.userId
        // row.appNo = !row.appNo ? '' : row.appNo
      }
      console.log(selectedMainRows)
      try {
        this.openLoading('searching')
        this.vToastifyPrompt(
          this.$t('Do you want to delete?'),
          'info',
            current => {
              epmsa220delete(selectedMainRows)
                .then(res => {
                  const result = res.body
                  if(result == 'Y'){
                    notify(this.$t('Delete is complete.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t(result), 'warn')
                  }
                })
                .catch(error => {
                  this.vToastify(error, 'warn')
                  this.endLoading()
                })
                .finally(() => {
                  this.plnCarryOutDte = ''                  
                  this.gridInstance.clearSelection()
                  this.getreqNoList()                  
                  this.getMain()
                  this.getMain2()
                })
            },
          null,
          true
        )
      } finally {
        this.endLoading()
      }
    },
   
    onValueChanged(value, cellInfo){
      console.log(cellInfo)
      for(let i = 0; i < this.gridMainList2.length; i++) {    
        this.gridMainList2[i].chk = value.value        
            if(value.value === true) {
               this.gridInstance2.selectRows(i, true)
              this.gridMainList2[i].chk = 'Y'              
            } else {
               this.gridInstance2.deselectRows(i, true)  
              this.gridMainList2[i].chk = 'N'              
            }
            this.gridInstance2.updateDimensions()
      }
      
    },

    onValueChanged2(value, cellInfo){
      if(cellInfo.data.chk == 'N') {
        this.gridMainList2[cellInfo.data.id].chk = 'Y'      
        this.gridInstance2.selectRows(cellInfo.data.id, true) 
      } else {        
        this.gridMainList2[cellInfo.data.id].chk = 'N'
        this.gridInstance2.deselectRows(cellInfo.data.id, true) 
      }
      this.gridInstance2.updateDimensions()
    },
   
    async cellPrepared(e){
       if(e.rowType === 'header'){

        if(e.column.caption === 'Por no'){
           if(e.columnIndex == '5'){
            e.cellElement.setAttribute('colspan' , 2)
           }else if(e.columnIndex == '6'){
            e.cellElement.style.display = 'none' 
           }        
        }
        
         if(e.column.caption === 'Mark No'){
          //console.log(e)
          if(e.columnIndex == '8'){
            e.cellElement.setAttribute('colspan' , 2)
           }else if(e.columnIndex == '9'){
            e.cellElement.style.display = 'none' 
           }        
         }
          
       }
    },
  },
}
</script>

<style lang="scss" scoped>
.search{
  font-weight: bold;
  color: black;
}
.top{
  background-color: #C0E0FF;
  border-left: 1px solid #B4BAC6;
}
.top2{
  background-color: #C0E0FF;
  border-top: 1px solid #B4BAC6;
}
.subText {
  border: 1px solid #B4BAC6;
  color: black;
}
$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
